import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

import { PageHeader } from '@/components/shared/PageHeader';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/hooks/useAuth';
import {
  NavigationOptionsSection,
  type NavigationOptionsSectionRef,
} from './navigation-options-section';

export function SettingsPage(): JSX.Element {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isRoot = user?.role === 'root';
  const sectionRef = useRef<NavigationOptionsSectionRef>(null);

  const handleCreateClick = (): void => {
    sectionRef.current?.openCreateDialog();
  };

  return (
    <div className="space-y-6 p-6">
      <PageHeader
        title={t('pages.settings.title')}
        description={t('pages.settings.description')}
        actions={
          isRoot ? (
            <Button onClick={handleCreateClick}>
              <Plus className="mr-2 h-4 w-4" />
              {t('pages.settings.actions.create')}
            </Button>
          ) : undefined
        }
      />
      {isRoot ? (
        <NavigationOptionsSection ref={sectionRef} />
      ) : (
        <Card>
          <CardContent className="p-6 text-sm text-muted-foreground">
            {t('pages.settings.rootOnly')}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
